import React from 'react';

const AvatarDefault = ({ color = '#b42a2a', size = 100 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 75 75"
    width={size}
    height={size}
  >
    <defs>
      <clipPath id="defaultClipA">
        <path d="M4.27 4.27H71V71H4.27Z" />
      </clipPath>
      <clipPath id="defaultClipB">
        <path d="M14.45 20H60.2v35.23H14.45Z" />
      </clipPath>
    </defs>

    <g clipPath="url(#defaultClipA)">
      <path
        fill={color}
        d="M37.5 70.72A33.26 33.26 0 0 1 4.27 37.5 33.26 33.26 0 0 1 37.5 4.27 33.26 33.26 0 0 1 70.72 37.5 33.26 33.26 0 0 1 37.5 70.72Zm0-64.66A31.47 31.47 0 0 0 6.06 37.5 31.47 31.47 0 0 0 37.5 68.94 31.47 31.47 0 0 0 68.94 37.5 31.47 31.47 0 0 0 37.5 6.06Z"
      />
    </g>

    <g clipPath="url(#defaultClipB)">
      <path
        fill={color}
        d="M60.2 51.98V24l-1.62.02v-1.93h-.53c-.64 0-1.26.01-1.87.03v-2.06h-.53c-12.01 0-18.24 4.9-18.3 4.95l-.02.02-.02-.02c-.06-.05-6.3-4.95-18.3-4.95h-.54v2.06c-.6-.02-1.22-.03-1.86-.03h-.54V24h-1.62v28c15.1 0 22.88 3.17 22.88 3.17s7.78-3.18 22.87-3.18Zm-43.06-28.88c.45 0 .9.02 1.33.03v24.98c0 .07.01.14.03.18.1.2.15.19.18.22l.08.06.78.37v-.31c5.59.07 9.82 1.22 12.69 2.37.53.21 1.01.43 1.45.64-3.28-.89-8.8-1.96-16.54-2.01Zm15.09.35a24 24 0 0 1 4.14 2.16l.07.04v26.31c-2.06-1.3-7.76-4.25-16.9-4.36V21.07c5.59.07 9.82 1.23 12.69 2.38Zm22.9-2.38V47.6c-9.16.11-14.85 3.06-16.9 4.36v-26.3c1.09-.79 6.8-4.46 16.9-4.59Zm2.39 28.56a65.55 65.55 0 0 0-16.54 2c2.84-1.34 7.7-2.99 14.55-3l.65.3v-25.8l1.34-.03Z"
      />
    </g>
  </svg>
);

export default AvatarDefault;
